import { useAppDispatch } from 'hooks/redux';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import React, { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { actions, selectors } from 'store/ducks';
import styled from 'styled-components';
import { Modal } from 'widgets/common';

type ThanksModalProps = {
  isBad?: boolean;
  isReturningMoney?: boolean;
};

export const ThanksModal: FC<ThanksModalProps> = ({ isBad, isReturningMoney }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation('utils');
  const isVisible = useSelector(selectors.app.selectIsVisibleThanksModal);

  const onClose = useCallback(() => {
    if (isVisible) {
      dispatch(actions.app.setIsVisibleThanksModal(false));
      dispatch(actions.app.setIsVisibleReviewMobileModal(true));
    }
  }, [dispatch, isVisible]);

  if (!isVisible) {
    return null;
  }

  const getText = () => {
    if (isBad) {
      if (isReturningMoney) {
        return t('modals.expertReviewBad.weReturnMoney');
      }
      return t('modals.expertReviewBad.weReadReview');
    }
    return t('modals.thanksModal.description');
  };

  return (
    <Modal isVisible={isVisible} onClose={onClose}>
      <Container>
        <Title>{isBad ? t('modals.expertReviewBad.title') : t('modals.thanksModal.title')}</Title>
        <Description>{getText()}</Description>
        <Image src="/img/thanks-modal-image.png" width={260} height={194} />
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  text-align: center;
`;
const Title = styled.h3`
  font-size: 17px;
  font-weight: bold;
  line-height: 20px;
  margin-bottom: 15px;
  white-space: pre-line;
`;
const Description = styled.p`
  font-size: 13px;
  line-height: 20px;
  margin-bottom: 25px;
`;
